/**
 * 토크 형태. 말풍선, 박스
 */
export enum TalkShapeType {
  Bubble = 'bubble',
  Box = 'box',
  None = 'none',
}
